<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <h4 class="title">Listado de eps registradas en el sistema</h4> -->
          <br/>
    </div>
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-3">
          <button class="btn btn-primary btn-sm" @click="abrirModal()"> <i class="ti-plus"></i> Nueva Estrategía</button>
        </div>
        <div class="col-sm-9">
            <label>
              <input type="search" style="width:220%" class="form-control" placeholder="Buscar estrategia..." v-model="searchQuery" aria-controls="datatables">
            </label>
          <div class="pull-right">
             <el-select
            class="select-default"
            v-model="pagination.perPage" 
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          </div>
        </div>
        <div class="col-sm-12">
            <br/>
          <el-table class="table-striped table-responsive"
                    :data="queriedData"
                    border
                    max-height="400"
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label" else>
            </el-table-column>
             <el-table-column
              :min-width="50"
              label="Estado">
              <template slot-scope="props">
                  <p v-if="props.row.DomEst==1"  slot="title-label" class="label label-success">
                      activa
                  </p>
                  <p v-else  slot="title-label" class="label label-danger">Inactiva</p>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="40"
              fixed="right"
              label="Acc">
              <template slot-scope="props">
                <button v-if="props.row.DomEst==2" class="btn btn-simple btn-xs btn-info btn-icon check" @click="activar(props.row)"><i class="ti-check"></i></button>
                <button v-else class="btn btn-simple btn-xs btn-warning btn-icon edit" @click="desactivar(props.row)"><i class="ti-close"></i></button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
            <br/>
          <p class="category">Mostrando del {{from + 1}} al {{to}} de {{total}} registros</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
    <!-- 
            primer modal-->
            <div
              class="modal fade"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              :class="{'mostrar' : modalRegistrar}"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header CM" style="padding: 8px; ">
                    <strong class="modal-title" id="exampleModalLongTitle">
                      <i class="fa fa-plus"></i>
                        Nuevo motivo de consulta
                    </strong>
                    <button type="button" @click="modalRegistrar=0" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                     <form @submit.prevent="nuevoDominio">
                        <label for>Codigo:</label>
                        <input type="text" disabled class="form-control" />

                        <label for>Descripcion:</label>
                        <textarea
                          v-model="descripcion"
                          required
                          cols="30"
                          rows="3"
                          class="form-control"
                        ></textarea>

                        <br />
                        <br />

                        <div class="row">
                          <div class="col-md-6">
                            Estrategía de Psicología <input v-model="tipo" value="26" type="radio">
                          </div>
                           <div class="col-md-6">
                             Estrategía de Terapia ocupacional <input v-model="tipo" value="24" type="radio">
                          </div>
                           <div class="col-md-6"> <br>
                             Estrategía de Fonoaudiología <input v-model="tipo" value="23" type="radio">
                          </div> <br>
                           <div class="col-md-6"> <br>
                             Estrategía de Fisioterapia <input v-model="tipo" value="22" type="radio">
                          </div> <br>
                           <div class="col-md-6"> <br>
                             Estrategía de Educación Especial<input v-model="tipo" value="25" type="radio">
                          </div>

                        </div>

                        <center> <br> 
                          <button
                            type="submit"
                            class="btn btn-success btn-sm"
                          >
                            <i class="fa fa-plus"></i> Enviar Datos
                          </button>
                          <button
                            type="button"
                            @click="limpiarFormulario()"
                            class="btn btn-danger btn-sm"
                          >
                            <i class="ti-close"></i>
                          </button>
                        </center>
                      </form>

                  </div>
                  <center>
                  </center>
                  <br />
                </div>
              </div>
            </div>
            <!-- fin primer modal -->
  </div>
</template>
<script>
import axios from "axios"
import Vue from 'vue'
import {Table, TableColumn, Select, Option} from 'element-ui'
import PPagination from 'src/components/UIComponents/Pagination.vue'
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
export default {
  data() {
    return {
    //   configuracion
      ip : 'https://avanti-erp.com/',
      descripcion: "",
      tipo: 22,
      modalRegistrar: 0,

      // notificaciones
       type: ['', 'info', 'success', 'warning', 'danger'],
        notifications: {
        topCenter: false
      },

      //   tabla
    pagination:
    {
        perPage: 7,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
    },
    searchQuery: '',
    propsToSearch: ['DomDes'],
    tableColumns: [
          {
            prop: 'DomDes',//NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
            label: 'Nombre', //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
            minWidth: 150 //ANCHO DE LA COLUMNA
          }
    ],
    arrayMotivo:[]
     
    }
  },

  computed: {

      pagedData () {
        return this.arrayMotivo.slice(this.from, this.to)
      },
      /*
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.arrayMotivo.length
          return this.pagedData
        }
        let result = this.arrayMotivo
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toLowerCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.arrayMotivo.length
        return this.arrayMotivo.length
      }
   
  },
  components: {
      PPagination
    },

  methods: {
    abrirModal(){
        this.modalRegistrar = 1;
    },
    nuevoDominio() {
        let config = {
            headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }
      var url = this.ip+'api/nuevoDominio';
      axios
        .post(url, {
          descripcion: this.descripcion,
          tipo: this.tipo
        }, config)
        .then(response => {
          var color = Math.floor((Math.random() * 4) + 1)
            this.$notify(
                {
                    component: {
                     template: ` <div style="padding: 3%;">
              <span><b> REGISTRADO CON ÉXITO </b>.</span>
              </div>
              `,
                },
                icon: 'ti-check',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: this.type[color]
            });
          this.tipo =   22;
          this.descripcion = "";
          this.modalRegistrar = 0;
          // this.motivos();
          this.estrategias();
        })
        .catch(error => {
          console.log(error);
        });
    },
    desactivar(patologia = []){
        let config = {
            headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }
        const url = this.ip+'api/desactivarDominio';
        axios.put(url, {
            id : patologia.DomIde
        }, config)
        .then(response => {
            var color = Math.floor((Math.random() * 4) + 1)
            this.$notify(
                {
                    component: {
                    template: ` <div style="padding: 3%;">
              <span><b> DESACTIVADO CON ÉXITO </b>.</span>
              </div>
              `,
                },
                icon: 'ti-check',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: this.type[color]
            });
            // this.motivos();
            this.estrategias();
        }).catch(error => {
            console.log(error);
        });
    },
    activar(patologia = []){
        let config = {
            headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        }
        const url = this.ip+'api/activarDominio';
        axios.put(url, {
            id : patologia.DomIde
        }, config)
        .then(response => {
            var color = Math.floor((Math.random() * 4) + 1)
            this.$notify(
                {
                    component: {
                     template: ` <div style="padding: 3%;">
              <span><b> ACTIVADO CON ÉXITO </b>.</span>
              </div>
              `,
                },
                icon: 'ti-check',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: this.type[color]
            });
            // this.motivos();
            this.estrategias();
        }).catch(error => {
            console.log(error);
        });
    },

    estrategias() {
        let config = {
        headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }
      var url = this.ip+"api/allEstrategias";
      axios
        .get(url, config)
        .then(response => {
            this.arrayMotivo = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    dominio(dominio){
       let config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        }
      var url = this.ip+"api/dominio/"+dominio;
      axios.get(url, config).then(res =>{
        return res.data.data;
      })
    },

    limpiarFormulario() {
      this.descripcion = "";
      this.tipo = 26;
    }
  },
  mounted() {
    // console.log("Component mounted.");
    if(!localStorage.getItem('token')){
      this.$router.push('/')
    }else{
      this.estrategias();
    }
  },
};
</script>  
<style>
.mostrar {
  display: list-item !important;
  opacity: 1 !important;
  position: absolute !important;
  background-color: #3c29297a;
  padding-top: 15%;
}
.modal-content {
  width: 100% !important;
  position: absolute !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mantenimiento/mantenimiento-estrategias.vue